// LANDARIS — agrega sombra al header cuando se hace scroll
// Pega este archivo en assets/custom-header.js
document.addEventListener('DOMContentLoaded', function () {
  var headerWrapper = document.querySelector('.header-wrapper');
  if (!headerWrapper) return;

  function toggleScrollState() {
    if (window.scrollY > 10) {
      headerWrapper.classList.add('is-scrolled');
    } else {
      headerWrapper.classList.remove('is-scrolled');
    }
  }

  toggleScrollState();
  window.addEventListener('scroll', toggleScrollState, { passive: true });
});
